<script setup lang="ts">
interface Props {
  mobile: boolean
}
const props = defineProps<Props>()
const store = useStore()
const { shopInformation } = storeToRefs(store)
const user = useCookie('auth.token')
const phone = `tel:+48${shopInformation.value.shopInformation.phone.replaceAll(' ', '')}`
const mail = `mailto:${shopInformation.value.shopInformation.contactEmail}`
const menu = reactive([
  { url: '/rezerwacja', icon: 'icon-mam-voucher', name: 'Mam voucher', color: 'primary' },
  { url: '/i/dla-firm', icon: 'icon-oferta-dla-firm', name: 'Oferta dla firm', color: 'primary' },
  { url: '/u/logowanie', icon: 'icon-zaloguj-sie', name: 'Zaloguj się', color: 'primary', hide: computed(() => user.value) },
  { url: '/u/moje-konto', icon: 'icon-zaloguj-sie', name: 'Moje konto', color: 'primary', hide: computed(() => !user.value) },
  { url: phone, icon: 'icon-zadzwon', name: 'Zadzwoń', color: 'menu', href: true },
  { url: mail, icon: 'icon-napisz-do-nas', name: 'Napisz do nas maila', color: 'menu', href: true }
])
</script>

<template>
  <ul v-if="mobile" class="text-14 p-[20px]">
    <li v-for="link in menu" :key="link.name">
      <NuxtLink v-if="!link.hide" :to="link.url" class="flex items-center text-menu border-b border-solid border-gray-400 p-[10px]">
        <i :class="`${link.icon} text-${link.color} w-[50px]`" />
        <span>{{ link.name }}</span>
      </NuxtLink>
    </li>
  </ul>
  <ul v-else>
    <li class="group">
      <NuxtLink to="/kontakt" class="flex flex-col items-center text-gray-400">
        <i class="icon-phone text-[20px]" />
        <span class="text-12">Kontakt</span>
      </NuxtLink>
      <ul class="hidden absolute left-[-90px] w-[210px] bg-white p-[20px] group-hover:block">
        <li v-for="link in menu" :key="link.name">
          <div v-if="!link.hide">
            <NuxtLink v-if="link.href" :to="link.url" class="flex items-center text-menu hover:text-menu-hover border-b border-solid border-gray-400 p-[10px]">
              <i :class="`${link.icon} text-${link.color} text-14 w-[40px]`" />
              <span class="text-12">{{ link.name }}</span>
            </NuxtLink>
            <NuxtLink v-else :to="link.url" class="flex items-center text-menu hover:text-menu-hover border-b border-solid border-gray-400 p-[10px]">
              <i :class="`${link.icon} text-${link.color} text-14 w-[40px]`" />
              <span class="text-12">{{ link.name }}</span>
            </NuxtLink>
          </div>
        </li>
      </ul>
    </li>
  </ul>
</template>
